import { acquireTokenAsync } from "./auth";

// Authenticated binary download. fetchApi only reads JSON/text, so it cannot return a
// file body; this helper attaches the Bearer token, fetches the response as a blob, and
// saves it to disk under the given file name.
export async function downloadFileApi(url, fileName) {
  const tokenResponse = await acquireTokenAsync();
  const options = {
    credentials: "include",
    method: "GET",
  };
  if (tokenResponse) {
    options.headers = new Headers({ Authorization: "Bearer " + tokenResponse.accessToken });
  }

  const response = await fetch(url, options);
  if (!response.ok) {
    throw new Error(`Download failed with status ${response.status}.`);
  }

  const blob = await response.blob();
  saveBlob(blob, fileName);
}

// Saves text the page already holds, with no request involved — the saved-grid-layout export builds
// its file contents client-side. Shares saveBlob with downloadFileApi so there is one anchor-click
// save in the app rather than a hand-rolled second one.
export function saveTextAsFile(fileName, text) {
  saveBlob(new Blob([text], { type: "text/plain;charset=utf-8" }), fileName);
}

function saveBlob(blob, fileName) {
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(objectUrl);
}
